import React, { useEffect, useState } from 'react';
import "../styles/HostelDetails.css";

const HostelDetails = () => {
  const [hostelData, setHostelData] = useState([]);

  useEffect(() => {
    fetch('https://gptkpm.in/backend/hostel/code/fetch_hostel_data.php') // Adjust the URL
      .then((response) => response.json())
      .then((data) => setHostelData(data))
      .catch((error) => console.error('Error fetching hostel data:', error));
  }, []);

  

  return (
    <div className='contact-section1'>
      <div className='contact-container'><h2>Contact Us</h2></div>
        <div className="hostel-container">
          {hostelData.map((hostel) => (
            <div key={hostel.id} className="hostel-card">
              <img
                src={`data:image/jpeg;base64,${hostel.profile}`}
                alt={hostel.name}
              />
              <h3>{hostel.name}</h3>
              <p><strong>Profession:</strong> {hostel.profession}</p>
              <p><strong>Phone:</strong> {hostel.phone_number}</p>
              <p><strong>Email:</strong> {hostel.email}</p>
            </div>
          ))}
        </div>
    </div>
  );
};

export default HostelDetails;
